<template>
  <div v-bind:style="{
    'padding-bottom': !$vuetify.breakpoint.mdAndUp  ? '56px' : 'initial',
  }">
    <list-navigator
      v-bind:style="{
        zIndex: $vuetify.breakpoint.mdAndUp ? 'initial': '10',
      }"
      v-if="detailView"
      backButtonHref="/notifs"
      :disabled="detailViewData.loading"
      :total="listViewData.items.length"
      :current="currentItemIndex"
      @navigate="(idx) => viewItemDetails(idx)"
    />

    <router-view v-on:request="request" v-bind="viewData" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ListNavigator } from '@/components';
import NotificationsListView from './NotificationsListView.vue';
import NotificationsDetailView from './NotificationsDetailView.vue';

export {
  NotificationsListView,
  NotificationsDetailView,
};

export default {
  components: { ListNavigator },
  data() {
    return {
      listViewData: {
        lastSearchArgs: {},
        items: [],
        loading: false,
        isPagination: false,
      },
      detailViewData: {
        item: null,
        backButton: false,
        loading: false,
        itemAllList: [],
      },
      currentView: null,
      idNotificationDetails: String,
    };
  },
  computed: {
    listView() {
      return this.currentView === 'list';
    },
    detailView() {
      return this.currentView === 'detail';
    },
    currentItemIndex() {
      const currentItemId = this.idNotificationDetails;
      return this.listViewData.items
        .findIndex((item) => item.id.toString() === currentItemId.toString());
    },
    viewData() {
      let data = {};
      if (this.listView) {
        data = this.listViewData;
      } else if (this.detailView) {
        data = this.detailViewData;
      }
      return data;
    },
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
  },
  methods: {
    isCitizen() {
      return this.user.hasIosUser();
    },
    viewItemDetails(idx) {
      const item = this.listViewData.items[idx];
      if (item != null) {
        this.detailViewData.item = item;
        this.$router.push(`/notifs/${item.id}`);
      }
    },
    request({ type, args }) {
      this.currentView = type;
      switch (type) {
      case 'list':
        this.getNotificationsList(args);
        break;
      case 'detail':
        this.idNotificationDetails = args.id.toString();
        this.getNotificationDetail(args);
        break;
      default: console.warn(`some NotificationsView children requested unmapped data (${type})`);
      }
    },
    async getNotificationDetail({ id: idNoti }) {
      const page = 1;
      const data = this.detailViewData;
      data.loading = true;

      if (this.listViewData.items.length === 0) {
        try {
          const feedbacksResponse = await this.getFeedback(page);
          const sortedFeedbacks = this.sortFeedbacks({ feedbacksResponse });
          this.listViewData.items = [...sortedFeedbacks];
        } catch (ex) {
          console.error('error getting notifications', ex);
        }
      }

      try {
        const { id, userid } = this.$store.getters['session/user'];
        const apiCges = {
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `gestnotif/notificaciones/${ idNoti }`,
          },
          id,
        };
        const response = await this.client.notifById(apiCges);

        data.item = response;
      } catch (ex) {
        console.error(`error getting notification detail (id=${ idNoti })`, ex);
      }

      data.loading = false;
    },
    async getNotificationsList({ page = 1 }) {
      const data = this.listViewData;

      if (page === 0) {
        data.items = [];
      } else {
        data.loading = true;
        try {
          const feedbacksResponse = await this.getFeedback(page);

          const sortedFeedbacks = this.sortFeedbacks({ feedbacksResponse });
          if (page === 1) {
            data.items = [];
          }

          const feedbacksList = [...data.items, ...sortedFeedbacks];
          data.items = [...feedbacksList];
          this.detailViewData.itemAllList = feedbacksList;
        } catch (ex) {
          data.loading = false;
          console.error('error getting notifications', ex);
        }
      }

      data.loading = false;
    },
    async getFeedback(page) {
      const { id, userid } = this.$store.getters['session/user'];

      const apiCges = {
        apiCges: {
          delegado: userid,
          uuidSuscriptor: id,
          endpoint: 'gestnotif/feedbacks',
          page,
        },
      };
      const response = await this.client.listFeedback(apiCges);

      const { feedback } = response;
      return feedback;
    },
    sortFeedbacks({ feedbacksResponse }) {
      return feedbacksResponse.sort((a, b) => {
        const [dayA, monthA, yearA] = a.creationDate.split('/');
        const [dayB, monthB, yearB] = b.creationDate.split('/');

        const dateA = new Date(`${yearA}-${monthA}-${dayA}`);
        const dateB = new Date(`${yearB}-${monthB}-${dayB}`);

        return dateB - dateA;
      });
    },
  },
  async created() {
    if (this.isCitizen()) {
      this.$store.dispatch('messages/createNotificationMessage', {
        title: 'No tienes acceso para visualizar este módulo',
        type: 'error',
        timeout: this.$getConst('notifications.timeoutPlus'),
        dismissible: true,
      });
      this.$router.push('/');
    } else {
      this.client = this.$api.getClient('notifications');
    }
  },
};
</script>

<style lang="scss">
  $notifications-navigator-top: 8px;
  $notitications-navigator-right: 40px;

  .notification-card-icon {
    > div {
      border-radius: 50%;
    }
  }

  #notifications-desktop-navigator > .v-toolbar__content {
    width: 100%;
  }

  @media screen and (min-width: 960px) {
    .v-application--is-ltr .v-toolbar__content
    > .v-btn.v-btn--icon:first-child, .v-application--is-ltr .v-toolbar__extension
    > .v-btn.v-btn--icon:first-child {
      margin-left: 0 !important;
    }

    #notifications-desktop-navigator {
      top: $notifications-navigator-top;
      right: $notitications-navigator-right;
    }
  }
</style>
